module.exports = __webpack_public_path__ + "img/zhaob.c26e0df.png";